import { useCallback, useEffect, useRef, useState } from "react";
import Select from "react-select";
import { useParams} from "react-router-dom";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import { debounce } from "@mui/material";
import printJS from "print-js";

//Img
import imgPeople from '../../../../../assets/image/addProducts/people1.jpg';
import imgAdd from '../../../../../assets/image/addProducts/imgAdd.png';
import frame from '../../../../../assets/image/addProducts/Frame.png';

//Css

//Components
import { HeaderImage } from "../../../shared/header_image/HeaderImage";
import { UserInformation } from "../../../shared/user_information/UserInformation";
import { CompanyReportPrinting } from "../../reports_module/report_company/report/CompanyReportPrinting";
import { Loading } from "../../../shared/loading/Loading";
import { SmartTable } from "../../../../../shared/ui/smart-table";
import { escapeHtml } from "../../../../../shared/lib/escapeHtml";
import AlertComponent from "../../../../../helpers/alert/AlertComponent";

//Services
import { userServices } from "../../../../../helpers/services/UserServices";
import { productForPurchaseOrderServices } from "../../../../../helpers/services/ProductForPurchaseOrderServices";
import { reportServices } from "../../../../../helpers/services/ReportServices";

//Enum
import { ResponseStatusEnum } from "../../../../../helpers/GlobalEnum";

export const CreateOrder = () => {

    const params = useParams();
    const headlineReportRef = useRef();

    const [userData, setUserData] = useState({});
    const [options, setOption] = useState([]);
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [saldoRestante, setSaldoRestante] = useState(0);
    const [subtotal, setSubtotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [headLineInformation, setHeadLineInformation] = useState({});
    const [isReportLoading, setIsReportLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const getProductDisplayName = (product) => {
        if (typeof product === "string") return product;

        return (
            product?.nombre ||
            product?.name ||
            product?.producto?.nombre ||
            product?.producto?.name ||
            product?.producto ||
            product?.nombre_producto ||
            product?.producto_nombre ||
            product?.Producto ||
            product?.Producto_Nombre ||
            ""
        );
    };

    const buildProductMarketErrorHtml = (errorMessage, productNames) => {
        const safeMessage = escapeHtml(errorMessage || "Hubo un error al intentar agregar el producto.");
        if (!productNames?.length) {
            return `<p style="margin: 0; text-align: left;">${safeMessage}</p>`;
        }

        const items = productNames
            .map((name) => `<li style="margin: 0 0 4px 0;">${escapeHtml(name)}</li>`)
            .join("");

        return `
            <div style="text-align: left;">
                <p style="margin: 0 0 8px 0;">${safeMessage}</p>
                <div style="margin: 0 0 6px 0; font-weight: 600;">Productos:</div>
                <div style="max-height: 86px; overflow: auto; padding-right: 4px;">
                    <ul style="margin: 0 0 0 16px; padding: 0;">${items}</ul>
                </div>
            </div>
        `;
    };

    const showProductMarketError = (errorMessage, productosAlterados = [], fallbackProductName = "", title = "Error") => {
        const normalizedProducts = Array.isArray(productosAlterados) ? productosAlterados : [];
        const productNames = normalizedProducts
            .map(getProductDisplayName)
            .filter(Boolean);

        if (!productNames.length && fallbackProductName) {
            productNames.push(fallbackProductName);
        }

        AlertComponent.Error(title, buildProductMarketErrorHtml(errorMessage, productNames));
    };

    const buildOrderSaveErrorHtml = (errorData) => {
        const safeMessage = escapeHtml(
            errorData?.detalle || "No fue posible guardar los productos."
        );
        const invalidPrices = Array.isArray(errorData?.precios_fuera_rango)
            ? errorData.precios_fuera_rango
            : [];

        if (!invalidPrices.length) {
            return `<p style="margin: 0; text-align: left;">${safeMessage}</p>`;
        }

        const items = invalidPrices
            .map((item) => {
                const productName = escapeHtml(item?.nombre || `Producto ${item?.producto_id || ""}`.trim());
                const productMessage = escapeHtml(item?.mensaje || "Precio fuera del rango permitido.");

                return `
                    <li style="margin: 0 0 8px 0;">
                        <div style="font-weight: 600;">${productName}</div>
                        <div>${productMessage}</div>
                    </li>
                `;
            })
            .join("");

        return `
            <div style="text-align: left;">
                <p style="margin: 0 0 8px 0;">${safeMessage}</p>
                <div style="margin: 0 0 6px 0; font-weight: 600;">Productos con precio fuera de rango:</div>
                <div style="max-height: 160px; overflow: auto; padding-right: 4px;">
                    <ul style="margin: 0 0 0 16px; padding: 0;">${items}</ul>
                </div>
            </div>
        `;
    };

    //Obtener la información del usuario
    const getUserInformation = async (cubId) => {
        try {
            const { data, status} = await userServices.userInformation(cubId);

            if(status === ResponseStatusEnum.OK) {
                setUserData(data);
                setSaldoRestante(data.monto_proveedores);
            }
        } catch (error) {
            handleError(error, 'Error buscando productos:');
        }
    }

    //Buscar producto
    const getOptionsProducts = useCallback(
        debounce(async (searchWord) => {
            if (searchWord.length < 3) {
                setOption([]);
                return;
            }

            try {
                const { data, status } = await productForPurchaseOrderServices.searchProduct(searchWord);
                if (status === ResponseStatusEnum.OK) {
                    const formattedOptions = data.map((product) => ({
                        value: product.id,
                        label: product.nombre,
                    }));
                    setOption(formattedOptions);
                }
            } catch (error) {
                handleError(error, "Error buscando productos:");
            }
        }, 300),
        []
    );

    //Adicionar item a la tabla
    const addItemToTable = async () => {
        if (selectedItem) {
            try {
                //Obtenemos los datos completos del producto desde el servicio
                const { data, status } = await productForPurchaseOrderServices.getProductId(selectedItem.value);

                const productErrorMessage =
                    data?.error ||
                    data?.message ||
                    data?.detail ||
                    data?.errors?.[0]?.title ||
                    data?.errors?.[0]?.detail ||
                    null;

                if (status === ResponseStatusEnum.BAD_REQUEST || productErrorMessage) {
                    showProductMarketError(
                        productErrorMessage || "No fue posible agregar el producto.",
                        data?.productos_alterados,
                        selectedItem?.label
                    );
                    return;
                }

                if(!data) {
                    AlertComponent.error('Error', 'El producto no tiene valor total configurado!');
                    return;
                }

                const valorUnitario = parseInt(data?.valor_unitario);

                // Agregar el producto con los datos
                setItems([...items, {
                    id: data.id,
                    nombre: data.nombre,
                    unidad: data.unidad,
                    valor_unitario: valorUnitario ?? 0,
                    quantity : 1,
                    discount: '0'
                }]);
                // Reset the select
                setSelectedItem(null);
            } catch (error) {
                handleError(error, 'Error agregando producto a la tabla:');
            }
        }
    };

    //
    const handleQuantityChange = (index, value) => {
        const newItems = [...items];
        newItems[index].quantity = value;
        setItems(newItems);
    };

    //
    const handleDiscountChange = (index, value) => {
        const newItems = [...items];
        newItems[index].discount = value;
        setItems(newItems);
    };

    //Eliminar un itema de la tabla
    const handleDeleteItem = (index) => {
        const newItems = items.filter((_, i) => i !== index);
        setItems(newItems);
    };

    //
    const limitToFourDecimals = (value) => {
        // Utilizamos una expresión regular para permitir números con hasta 4 decimales
        const regex = /^\d*\.?\d{0,4}$/;

        // Si el valor coincide con la expresión regular, lo devolvemos tal cual
        if (regex.test(value)) {
            return value;
        }

        // Si no coincide (tiene más de 4 decimales), truncamos a 4 decimales
        return parseFloat(value).toFixed(4);
    };

    //Enviar los productos
    const handleSaveProduct = async () => {
        const itemsWithTotal = calculateItemsWithTotal();
        const dataToSend = buildDataToSend(itemsWithTotal);

        try {
            const { data, status} = await productForPurchaseOrderServices.saveOrderProducts(dataToSend, params.id);
            handleSaveResponse(data, status);
        } catch (error) {
            handleError(error, 'Error al guardar los productos');
        }
    };

    //Calcula el total por cada item y mapea los datos necesarios
    const calculateItemsWithTotal = () => {
        return items
            .filter(item => item.quantity > 0)
            .map(item => {
                const discountRate = parseFloat(item.discount) || 0;
                const totalByItem = Math.ceil(item.valor_unitario * item.quantity * (1 - discountRate / 100));
                return {
                    producto: item.id,
                    discount: item.discount || 0,
                    cantidad: item.quantity,
                    valor_unitario: parseFloat(item.valor_unitario),
                    valor_final: totalByItem
                };
            });
    };

    //Construye la estructura de datos a enviar
    const buildDataToSend = (itemsWithTotal) => {
        return {
            persona_cub_id: params.id,
            valor_total: Math.ceil(total),
            items: itemsWithTotal
        };
    };

    //Maneja la respuesta del servicio y muestra la alerta correspondiente
    const handleSaveResponse = (data, status) => {
        if (status === ResponseStatusEnum.CREATED) {
            setSaldoRestante(parseFloat(data?.cub?.monto_proveedores));
            AlertComponent.success('Bien hecho!', 'Productos guardados exitosamente');
            resetProductList();

            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }

        if (status === ResponseStatusEnum.BAD_REQUEST) {
            AlertComponent.Error(
                'Error al guardar los productos',
                buildOrderSaveErrorHtml(data)
            );
        }
    };

    // Reinicia la lista de productos
    const resetProductList = () => {
        setIsReportLoading(true);
        setItems([]);
        setSelectedItem(null);
        setIsReportLoading(false);
    };

    //Maneja el error en caso de fallo de la llamada
    const handleError = (error, title) => {
        const errorMessage = error.response?.data?.message || error.message || 'Error desconocido';
        AlertComponent.error(title,errorMessage);
    };

    const getHeadlineReport = async (cubId) => {
        setIsLoading(true);
        try {
            const { data, status} = await reportServices.companyAndUserReport(cubId);
            if(status === ResponseStatusEnum.OK) {
                setHeadLineInformation(data);
                setIsReportLoading(true);
            }
        } catch (error) {
            handleError(error, 'Error al obtener el reporte:');
        } finally {
            setIsLoading(false);
        }
    };

    const handlePrintOrder = async () => {
        // Después de obtener la información, generar el contenido a imprimir
        const printContent = `
            <html>
            <head>
              <style>           
                body {
                  font-family: Arial, sans-serif;
                  margin: 20px;
                  font-size: 10px;
                }           
              </style>
            </head>
            <body>
              <!-- Inyectamos el HTML del componente -->
              ${headlineReportRef.current.innerHTML} 
            </body>
            </html>`;

        printJS({
            printable: printContent,
            type: 'raw-html',
            documentTitle: 'Reporte Beneficiario',
        });
    };

    //
    const validateProducts = () => {
        if(isNaN(total) || isNaN(saldoRestante)) {
            return true;
        }
        return total === 0 || saldoRestante < 0 ;
    };

    const productRows = items.map((item, index) => ({
        rowKey: `${item.id}-${index}`,
        index,
        id: item.id,
        nombre: item.nombre,
        valor_unitario: item.valor_unitario,
        unidad: item.unidad,
        quantity: item.quantity,
        discount: item.discount,
        total: item.valor_unitario * item.quantity * (1 - (parseFloat(item.discount) || 0) / 100),
    }));

    const columns = [
        {
            title: "COD",
            dataIndex: "id",
            key: "id",
            width: 110,
        },
        {
            title: "Nombre",
            dataIndex: "nombre",
            key: "nombre",
            width: 260,
        },
        {
            title: "Vr. Unitario",
            dataIndex: "valor_unitario",
            key: "valor_unitario",
            width: 160,
            render: (value) => `$${Number(value || 0).toLocaleString()}`,
        },
        {
            title: "Unidad",
            dataIndex: "unidad",
            key: "unidad",
            width: 130,
        },
        {
            title: "Cantidad",
            dataIndex: "quantity",
            key: "quantity",
            width: 140,
            render: (_, record) => (
                <Form.Control
                    type="number"
                    className="small-input form-control-sm"
                    value={record.quantity}
                    onChange={(e) => handleQuantityChange(record.index, e.target.value)}
                    min="1"
                />
            ),
        },
        {
            title: "Dto",
            dataIndex: "discount",
            key: "discount",
            width: 140,
            render: (_, record) => (
                <Form.Control
                    type="text"
                    className="small-input form-control-sm"
                    value={record.discount}
                    onChange={(e) => handleDiscountChange(record.index, limitToFourDecimals(e.target.value))}
                />
            ),
        },
        {
            title: "Total",
            dataIndex: "total",
            key: "total",
            width: 170,
            render: (value) => `$${Number(value || 0).toLocaleString()}`,
        },
        {
            title: "",
            dataIndex: "actions",
            key: "actions",
            width: 90,
            render: (_, record) => (
                <Button
                    variant="outline-danger"
                    onClick={() => handleDeleteItem(record.index)}
                >
                    <FaTrashAlt />
                </Button>
            ),
        },
    ];

    useEffect(() => {
        const subtotal = items.reduce((acc, item) => {
            const itemTotal = item.valor_unitario * item.quantity * (1 - (parseFloat(item.discount) || 0) / 100);
            return acc + itemTotal;
        }, 0);

        const total = subtotal;

        const saldoInicial = parseFloat(userData?.monto_proveedores || 0);
        const nuevoSaldo = saldoInicial - total;

        setSubtotal(subtotal);
        setTotal(total);
        setSaldoRestante(nuevoSaldo);
    }, [items]);

    useEffect(() => {
        if(isReportLoading) {
            handlePrintOrder();
            setIsReportLoading(false);
        }
    }, [isReportLoading]);

    useEffect(() => {
        if(params.id){
            getUserInformation(params.id);
        }
    },[]);

    return (
        <>
            <div className="main-container">
                <HeaderImage
                    imageHeader={imgPeople}
                    titleHeader={'¡Empieza a agregar tus productos!'}
                    bannerIcon={imgAdd}
                    backgroundIconColor={'#ff5722'}
                    bannerInformation={'Todo está listo para que completes tu pedido de forma rápida y sencilla.'}
                    backgroundInformationColor={'#0056b3'}
                />

                {/* Contenedor de la información del usuario */}
                <UserInformation userData={userData} />

                {/* Sección de búsqueda de productos */}
                <div className="search-banner">
                   <Container>
                        <Row className="justify-content-center">
                            <Col md={6} className="d-flex align-items-center">
                                <div className="select-container d-flex align-items-center">
                                    <Select
                                        className="basic-single flex-grow-1" // Agrega flex-grow-1 para que ocupe el espacio disponible
                                        classNamePrefix="select"
                                        isClearable
                                        value={selectedItem}
                                        onChange={setSelectedItem}
                                        options={options}
                                        onInputChange={(inputValue, { action }) => {
                                            if (action === "input-change") {
                                                getOptionsProducts(inputValue);
                                            }
                                        }}
                                        placeholder="Buscar productos..."
                                    />
                                    <Button variant="outline-success"
                                            disabled={parseFloat(saldoRestante) === 0}
                                            onClick={addItemToTable}
                                            className="addProductButton ms-2"
                                    >
                                        Agregar
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                   </Container>
                   {/* Imagen final del banner */}
                   <img src={frame} alt="Icono" className="banner-icon" />
                </div>

                {/* Tabla de productos */}
                <Container>
                    {/* Encabezado */}
                    <Row className="head-title-table d-flex mt-4" >
                        <Col md={12} sm={12} xl={8} className="mb-2">
                            {/* Contenedor del título */}
                            <div className="title-div">
                                <h3>FORMATO DE VENTA</h3>
                            </div>
                        </Col>
                        <Col md={12} sm={12} xl={4} className="mb-2">
                            {/* Contenedor del saldo */}
                            <div className="head-title-balance d-flex justify-content-center align-items-center mt-1">
                                <span style={{ fontSize: "25px", fontWeight: "bold", color: "#FFF" }}>
                                    Saldo: ${parseFloat(saldoRestante).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                </span>
                            </div>
                        </Col>
                    </Row>

                    {isLoading && <Loading text="Cargando..." />}

                    {/* Tabla */}
                    <div className="mt-3 scrollable-thead-body">
                        <SmartTable
                            rowKey="rowKey"
                            columns={columns}
                            dataSource={productRows}
                            total={productRows.length}
                            currentPage={1}
                            defaultPageSize={10}
                            pageSizeOptions={["10", "20", "50"]}
                            defaultText="---"
                            emptyText="No hay productos agregados."
                            enableRowSelection={false}
                            showToolbar={false}
                            showTableResize={false}
                            showColumnSettings={false}
                            scroll={{ x: 1200 }}
                        />
                    </div>

                    {/* Totales */}
                    <Row className="mt-2 justify-content-md-end justify-content-center">
                        <Col xs={12} md={6} className="text-end">
                            <p className="subtotal-text"><strong>SUBTOTAL:</strong> ${subtotal.toLocaleString()}</p>
                            <p className="total-text">TOTAL: ${total.toLocaleString()}</p>
                        </Col>
                    </Row>

                    {/* Botón Guardar */}
                    <Row className="mt-3 justify-content-md-end justify-content-center">
                        <Col xs="auto" className="text-center text-md-end">
                            <Button
                                variant="outline-info"
                                onClick={() => getHeadlineReport(params.id)}
                                disabled={isReportLoading}
                                className="button-responsive me-md-2 mb-2 mb-md-0"
                                style={{
                                    backgroundColor: isReportLoading ? "#ccc" : "#2148C0",
                                    borderColor: "#007BFF",
                                    fontWeight: "bold",
                                    color: "white",
                                    cursor: isReportLoading ? "not-allowed" : "pointer",
                                    opacity: isReportLoading ? 0.6 : 1,
                                }}
                            >
                                {isReportLoading ? (
                                    <span>Cargando...</span>
                                ) : (
                                    <>
                                        <i className="fas fa-print me-2"></i>IMPRIMIR ORDEN
                                    </>
                                )}
                            </Button>
                            <Button
                                variant="outline-success"
                                onClick={handleSaveProduct}
                                disabled={validateProducts()}
                                className="button-responsive"
                                style={{
                                    backgroundColor: validateProducts() ? "#ccc" : "#BFD732",
                                    borderColor: "#BFD732",
                                    fontWeight: "bold",
                                }}
                            >
                                <i className="fas fa-save me-2"></i>GUARDAR ORDEN
                            </Button>
                        </Col>
                    </Row>
                </Container>

            </div>

            <div style={{ display: 'none' }}>
                {headLineInformation && (
                    <div ref={headlineReportRef}>
                        <CompanyReportPrinting
                            titleReport={'ORDEN DE COMPRA'}
                            dataReport={headLineInformation}
                            userData={userData}
                            isCompanyReport={false}/>
                    </div>
                )}
            </div>
        </>
    )
}
